module.exports = __webpack_public_path__ + "static/media/aboutne.54dfcf46.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/aboutne.png
// module id = 120
// module chunks = 0